/* eslint-disable @next/next/no-img-element */
import { FC } from 'react'
import { BannerItem } from './wallOfLoveIterfaces'
import { Img } from 'components/basic/Img'
import styles from './WallOfLove.module.scss'
import { useMouseFaceTracking } from 'components/_hooks/useMouseFaceTracking'
import cx from 'classnames'
import { Type } from 'components/Type'

export const BannerCard: FC<BannerItem> = (props) => {
	const [containerRef, handleMouseMove, handleMouseLeave] = useMouseFaceTracking<HTMLDivElement>()

	return (
		<div
			className={cx(styles.container, 'wall-of-love-video')}
			ref={containerRef}
			onMouseMove={handleMouseMove}
			onMouseLeave={handleMouseLeave}
		>
			<div className={styles.bg}>
				<div className={styles.shade} />
				<Img
					src={props.image}
					alt={'Lewis Hamilton'}
					objectFit={'cover'}
					dprHeight={600}
				/>
			</div>
			<div className={cx(styles.article_content, 'article_content')}>
				<Type.Headchapter as={'h2'}>{props.name}</Type.Headchapter>
				<Type.Body2>{props.subtitle}</Type.Body2>
			</div>
		</div>
	)
}
